// Lightweight number formatting helpers for the Competitive Monitoring module.

export function fmtNumber(n) {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1e9) return (v / 1e9).toFixed(2) + 'B';
  if (Math.abs(v) >= 1e6) return (v / 1e6).toFixed(2) + 'M';
  if (Math.abs(v) >= 1e3) return (v / 1e3).toFixed(1) + 'K';
  return Math.round(v).toLocaleString();
}

export function fmtCurrency(n) {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1e6) return '$' + (v / 1e6).toFixed(2) + 'M';
  if (Math.abs(v) >= 1e3) return '$' + (v / 1e3).toFixed(1) + 'K';
  return '$' + v.toFixed(2);
}

export function fmtPercent(n) {
  return (Number(n) || 0).toFixed(2) + '%';
}

// Generic formatter used where the backend tells us the type.
export function fmt(value, type) {
  switch (type) {
    case 'currency': return fmtCurrency(value);
    case 'percent': return fmtPercent(value);
    default: return fmtNumber(value);
  }
}
